import { motion } from "framer-motion";
import { GraduationCap, Briefcase, UtensilsCrossed } from "lucide-react";

const industries = [
  {
    icon: Briefcase,
    title: "Service Businesses",
    benefit: "Get more booked appointments for dentists, consultancies, clinics, fitness centers and other high-value service providers",
  },
  {
    icon: GraduationCap,
    title: "Education Institutes",
    benefit: "Turn inquiries into enrolled students with automated nurturing",
  },
  {
    icon: UtensilsCrossed,
    title: "Restaurants",
    benefit: "Increase orders and bring customers back using content, ads, and automated follow-ups",
  },
];

const IndustriesSection = () => {
  return (
    <section className="py-24 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-display-md font-bold text-foreground mb-4">Who We Work With</h2>
          <p className="text-muted-foreground text-lg">Industries we specialize in.</p>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-6">
          {industries.map((industry, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-card border border-border rounded-2xl p-6 text-center hover:shadow-lg hover:border-primary/30 transition-all duration-300"
            >
              <div className="mx-auto mb-4 w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center">
                <industry.icon className="h-7 w-7 text-primary" />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-2">{industry.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{industry.benefit}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
